var render = function render(){var _vm=this,_c=_vm._self._c;return ((_vm.item.media && _vm.item.media['100w']) || _vm.item.color)?_c('div',[(_vm.item.media)?_c('img',{attrs:{"src":_vm.item.media['100w'].src,"width":_vm.size,"height":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.item.color)?_c('div',{style:({
      backgroundColor: _vm.item.color,
      width: `${_vm.size}px`,
      height: `${_vm.size}px`,
    })}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }